<template>
  <div class="form" enctype="multipart/form-data">
    <div class="container">
      <div class="form-container text-left">
        <button @click="$router.go(-1)" class="app-btn px-3 mb-4">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1"/> Atrás
        </button>
        <div class="d-flex justify-content-between">
          <h3>
            {{requestDetail.proyectName}} 
          </h3>
          <span>
            {{requestDetail.serviceDetail.requestedService.description}}
          </span>
        </div>
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
            Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
          </span>
          <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
            </div>
            <div class="application-number">
              #{{requestDetail.id}}
            </div>
        </div>
        </div>
        <h2 v-if="requestDetail.serviceDetail.requestedService.code != '9'  && requestDetail.serviceDetail.requestedService.code != '10'">Aprobar conexión</h2>
        <h2 v-if="requestDetail.serviceDetail.requestedService.code == '9'  || requestDetail.serviceDetail.requestedService.code == '10'">Certificado de disponibilidad del servicio</h2>
        <div class="input-wrap">
          <div class="row mb-3" v-if="requestDetail.serviceDetail.requestedService.code != '9' && requestDetail.serviceDetail.requestedService.code != '10'">
            <div class="col-3">
              <label for="chageApproved">Capacidad aprobada (kVA)</label>
              <input type="text" id="chageApproved" v-model="approvedConnection.chageApproved">
            </div>
            <div class="col-3">
              <label for="mediumTensionRed">Redes en media tensión</label>
              <select id="mediumTensionRed" v-model="approvedConnection.tensionNetwork">
                  <option value="1">Aérea</option>
                  <option value="2">Subterránea</option>
                  <option value="3">No aplica</option>
                </select>
            </div>
            <div class="col-6">
              <label for="tensionApproved">Nivel de tensión aprobado para el punto de conexión</label>
              <select id="tensionApproved" v-model="approvedConnection.tensionApproved">
                <option v-if="requestDetail.conectionType == 'Simple'" value="1">Nivel 1. Tensión menor a 1 kV</option>
                <option value="2">Tensión mayor o igual a 1 kV y menor a 30 kV</option>
                <option value="3">Tensión mayor o igual a 30 kV y menor a 57.5 kV</option>
              </select>
            </div>
          </div>
          <!-- (Redes de media tensión) aerea - subterranea
              (Redes en baja tensión) aerea - subterranea
              (Tipo de transformadior) interior - exterior -->
          <div class="row" v-if="requestDetail.serviceDetail.requestedService.code != '9'  && requestDetail.serviceDetail.requestedService.code != '10'">
            <div class="col">
              <div class="mb-3">
                <label for="connectionTypeS">Acometida en Media Tensión</label>
                <select id="connectionTypeS" v-model="approvedConnection.connectionTypeS">
                  <option value="3">Aérea</option>
                  <option value="4">Subterránea</option>
                  <option value="5">Aérea-Subterránea</option>
                  <option value="6">No aplica</option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label for="connectionTypeA">Acometida en Baja Tensión</label>
                <select id="connectionTypeA" v-model="approvedConnection.connectionTypeA">
                  <option value="1">Aérea</option>
                  <option value="2">Subterránea</option>
                  <option value="3">Aérea-Subterránea</option>

                </select>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label for="connectionTypeP">Tipo de Subestación a montar</label>
                <select id="connectionTypeP" v-model="approvedConnection.connectionTypeP">
                  <option value="5">Interior</option>
                  <option value="6">Exterior</option>
                  <option value="7">Exterior - Interior</option>
                  <option value="8">No aplica</option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="requestDetail.serviceDetail.requestedService.id <= 7">
            <div class="row mb-3">
              <div class="col-6">
                <label for="nodoReference">Nodo de referencia</label>
                <input type="text" id="nodoReference" v-model="approvedConnection.nodoReference">
              </div>
              <div class="col-6">
                <label for="transformerNumber">No. transformador</label>
                <input type="text" id="transformerNumber" v-model="approvedConnection.transformerNumber">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-4">
                <label for="kvaTransformerDistribution">kVA Transformador de Distribución</label>
                <input type="text" id="kvaTransformerDistribution" v-model="approvedConnection.kvaTransformerDistribution">
              </div>
              <div class="col-4">
                <label for="circutName">Nombre del circuito</label>
                <input type="text" id="circutName" v-model="approvedConnection.circutName">
              </div>
              <div class="col-4">
                <label for="circutNumber">Número del circuito</label>
                <input type="text" id="circutNumber" v-model="approvedConnection.circutNumber">
              </div>
            </div>
          </div>
          <div v-if="requestDetail.serviceDetail.requestedService.id == 8">
            <div class="row mb-3">
              <div class="col-4">
                <label for="circutNameMt">Nombre de Circuito</label>
                <input type="text" id="circutNameMt" v-model="approvedConnection.circutNameMt">
              </div>
              <div class="col-4">
                <label for="circutNumber">Número del circuito</label>
                <input type="text" id="circutNumber" v-model="approvedConnection.circutNumber">
              </div>
              <div class="col-4">
                <label for="ciurcuitLevel30">Nivel de cortocircuito 3Ø (kA)</label>
                <input type="text" id="ciurcuitLevel30" v-model="approvedConnection.ciurcuitLevel30">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label for="subestationPower">Nombre de Subestación de Potencia</label>
                <input type="text" id="subestationPower" v-model="approvedConnection.subestationPower">
              </div>
              <div class="col-6">
                <label for="ciurcuitLevel10">Nivel de cortocircuito 1Ø (kA)</label>
                <input type="text" id="ciurcuitLevel10" v-model="approvedConnection.ciurcuitLevel10">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label for="subestationDistance">Distancia a la Subestación (m)</label>
                <input type="text" id="subestationDistance" v-model="approvedConnection.subestationDistance">
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label for="impedance">Impedancia (x)</label>
                  <input type="text" id="impedance" v-model="approvedConnection.impedance">
                </div>
                <div>
                  <label for="redactance">Reactancia (R)</label>
                  <input type="text" id="redactance" v-model="approvedConnection.redactance">
                </div>
              </div>
            </div>
          </div>
          <div v-if="requestDetail.serviceDetail.requestedService.id == 9">
            <div class="row mb-3">
              <div class="col-6">
                <label for="nodo">Nodo</label>
                <input type="text" id="nodo" v-model="approvedConnection.nodo">
              </div>
              <div class="col-6">
                <label for="subestationPower">Nombre de Subestación de Potencia</label>
                <input type="text" id="subestationPower" v-model="approvedConnection.subestationPower">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-4">
                <label for="circutNameMt">Nombre de Circuito</label>
                <input type="text" id="circutNameMt" v-model="approvedConnection.circutNameMt">
              </div>
              <div class="col-4">
                <label for="circutNumber">Número del circuito</label>
                <input type="text" id="circutNumber" v-model="approvedConnection.circutNumber">
              </div>
              <div class="col-4">
                <label for="subestationDistance">Distancia a la Subestación (m)</label>
                <input type="text" id="subestationDistance" v-model="approvedConnection.subestationDistance">
              </div>
            </div>
          </div>
          <div v-if="requestDetail.serviceDetail.requestedService.id == 10">
            <div class="row mb-3">
              <div class="col-4">
                <label for="circutNameMt">Nombre de Circuito</label>
                <input type="text" id="circutNameMt" v-model="approvedConnection.circutNameMt">
              </div>
              <div class="col-4">
                <label for="circutNumber">Número del circuito</label>
                <input type="text" id="circutNumber" v-model="approvedConnection.circutNumber">
              </div>
              <div class="col-4">
                <label for="subestationPower">Nombre de Subestación de Potencia</label>
                <input type="text" id="subestationPower" v-model="approvedConnection.subestationPower">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-4">
                <label for="subestationDistance">Distancia a la Subestación (m)</label>
                <input type="text" id="subestationDistance" v-model="approvedConnection.subestationDistance">
              </div>
              <div class="col-4">
                <label for="ciurcuitLevel30">Nivel de cortocircuito 3Ø (kA)</label>
                <input type="text" id="ciurcuitLevel30" v-model="approvedConnection.ciurcuitLevel30">
              </div>
              <div class="col-4">
                <label for="ciurcuitLevel10">Nivel de cortocircuito 1Ø (kA)</label>
                <input type="text" id="ciurcuitLevel10" v-model="approvedConnection.ciurcuitLevel10">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-8">
                
              </div>
              <div class="col-4">
                <div class="mb-3">
                  <label for="impedance">Impedancia (x)</label>
                  <input type="text" id="impedance" v-model="approvedConnection.impedance">
                </div>
                <div>
                  <label for="redactance">Reactancia (R)</label>
                  <input type="text" id="redactance" v-model="approvedConnection.redactance">
                </div>
              </div>
            </div>
          </div>

          <div v-if="requestDetail.conectionType != 'Compleja'">
            <label><strong>Tipo y clase de carga aprobada</strong>  </label>
            <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Tipo de carga</th>
                    <th scope="col">Monofásica</th>
                    <th scope="col">Bifásica</th>
                    <th scope="col">Trifásica</th>                    
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="carga in tipoCargaList" :key="carga.id">
                  <td>
                    {{carga.tipoCarga == 'residencial' ? 'Residencial':''}}
                    {{carga.tipoCarga == 'comercial' ? 'Comercial':''}}
                    {{carga.tipoCarga == 'industial' ? 'Industial':''}}
                    {{carga.tipoCarga == 'oficial' ? 'Oficial':''}}
                    {{carga.tipoCarga == 'oficial' ? 'Oficial':''}}
                    {{carga.tipoCarga == 'alumbradoPublico' ? 'Alumbrado Publico':''}}
                    {{carga.tipoCarga == 'provisionalObra' ? 'Provisional de Obra':''}}
                    {{carga.tipoCarga == 'otro' ? 'Otro':''}}
                    {{carga.tipoCarga == 'totalPorCarga' ? 'Total por clase de carga':''}}
                    {{carga.tipoCarga == 'totalCargas' ? 'Número  total de cuentas':''}}
                  </td>
                  <td>{{carga.monofasica}}</td>
                  <td>{{carga.bifasica}}</td>
                  <td>{{carga.trifasica}}</td>
                  <td>{{carga.totalCargas}}</td>
                  </tr>
                </tbody>
              </table>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <label for="comments">Comentarios adicionales</label>
              <textarea id="comments" cols="20" rows="10" v-model="approvedConnection.comments"></textarea>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-4">
              <label class="file">Adjuntar documento <v-icon class="ml-2" name="upload" scale="1.5"/>
                <input @change="onFileChangeDocument($event)" type="file" >
                  <div class="file-selected" v-if="approvedConnection.documentCopy">
                    {{approvedConnection.documentCopy.name}} - 
                    <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                  </div>
              </label> 
            </div>
          </div>
          <div>
            <button v-if="requestDetail.serviceDetail.requestedService.code != '9'  && requestDetail.serviceDetail.requestedService.code != '10'" @click="confirmed = true; validarInput()" class="app-btn app-btn--green w-100">
              Aprobar conexión
            </button>
            <button v-if="requestDetail.serviceDetail.requestedService.code == '9'  || requestDetail.serviceDetail.requestedService.code == '10'" @click="confirmed = true; validarInput()" class="app-btn app-btn--green w-100">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <div v-if="confirmed == false" class="error-modal">
      <div @click="confirmAccept = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Realmente desea aprobar la solicitud?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAccept = true; confirmed = true; sendRequest()" class="app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAccept = false; confirmed = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedDoc == false" class="error-modal">
      <div @click="confirmAcceptDoc = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDoc = true; confirmedDoc = true; borrarDocumento()" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDoc = false; confirmedDoc = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";


export default {
  name: 'DesignDataForm',
  components: {
    
  },
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      loading: false,
      error: '', 
      confirmAccept: false,
      confirmed: true,     
      confirmedDoc: true,
      confirmAcceptDoc: false,
      tipoCargaList: [],
      arrayDocuments: [],
      approvedConnection: {
        chageApproved: '',
        tensionNetwork:'',
        tensionApproved: '',
        connectionTypeA: '',
        connectionTypeS: '',
        connectionTypeP: '',
        nodoReference: '',
        transformerNumber: '',
        kvaTransformerDistribution: '',
        circutName: '',
        circutNameMt: '',
        circutNumber: '',
        ciurcuitLevel30: '',
        ciurcuitLevel10: '',
        subestationPower: '',
        subestationDistance: '',
        impedance: '',
        redactance: '',
        nodo: '',
        comments: '',
        confirmAccept: false,
        confirmed: true,
        documentCopy: null
      }
    }
  },
  mounted(){
    this.tipoCargaRecord()
    console.log("requestDetail: ", this.requestDetail);
    window.onbeforeunload = function(){
      return '¿Estas seguro? Esto eliminará la información';
    };
  },
  methods:{
    
    tipoCargaRecord(){
    axios.get("/tipocarga/request/" + this.requestDetail.id)
    .then(response => {
      if (response.data.length != 0) {
        this.tipoCargaList = response.data;
      }
    })
    this.tipoCarga = false;
      return;        
    },
    borrarDocumento(){
      this.arrayDocuments = []; 
      this.approvedConnection.documentCopy = null;     
    },
    validarInputDocument(){
      this.confirmedDoc = false;
        return;        
    },
    onFileChangeDocument(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.approvedConnection.documentCopy = files;
        let documentCopy = {
          "anexo":reader.result,
          "description":files.name,
          "idApprovedConnection":1,
          "status":'Activo'
        };

        this.arrayDocuments.push(documentCopy);
      };

      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    validarInput(){
      this.confirmed = false; 
    },

    sendRequest(){
      this.loading = true;

      let approvedData = {
        "chageApproved":this.approvedConnection.chageApproved,
        "tensionNetwork":this.approvedConnection.tensionNetwork,
        "circutName":this.approvedConnection.circutName,
        "circutNameMt":this.approvedConnection.circutNameMt,
        "circutNumber":this.approvedConnection.circutNumber,
        "ciurcuitLevel10":this.approvedConnection.ciurcuitLevel10,
        "ciurcuitLevel30":this.approvedConnection.ciurcuitLevel30,
        "comments":this.approvedConnection.comments,
        "connectionTypeA":this.approvedConnection.connectionTypeA,
        "connectionTypeS":this.approvedConnection.connectionTypeS,
        "connectionTypeP":this.approvedConnection.connectionTypeP,
        "idKvRequieredApproved":this.approvedConnection.tensionApproved,
        "idRequest":this.requestDetail.id,
        "impedance":this.approvedConnection.impedance,
        "kvaTransformerDistribution":this.approvedConnection.kvaTransformerDistribution,
        "nodo":this.approvedConnection.nodo,
        "nodoReference":this.approvedConnection.nodoReference,
        "redactance":this.approvedConnection.redactance,
        "subestationDistance":this.approvedConnection.subestationDistance,
        "subestationPower":this.approvedConnection.subestationPower,
        "transformerNumber":this.approvedConnection.transformerNumber,
        "updateDate":new Date(),
        "createDate":new Date()
      }

      axios.post("approvedConnection/add", approvedData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.updateRequest();
        this.userActionLog();

        if (this.arrayDocuments.length > 0) {
          for (let i = 0; i < this.arrayDocuments.length; i++) {
            this.arrayDocuments[i].idApprovedConnection = result.data.id;
          }
          this.sendApprovedConnectionDocument(0);
        }else{
          this.loading = false;
          this.$router.go(-1);
        }
        
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },

    userActionLog(){

      let userAction = {
        "idRequest":this.requestDetail.id,
        "action": "Aprobó la solicitud",
        "email": localStorage.getItem('email'),
        "editedDate":new Date()
      }
      axios.post("userActionLogController/add", userAction, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(data =>{
        console.log("si agrego el log")
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'no agrego el log';
      })
    },

    sendApprovedConnectionDocument(index){

      let newObjectApprovedDocument = {
        "anexo": this.arrayDocuments[index].anexo,
        "description": this.arrayDocuments[index].description,
        "idApprovedConnection": this.arrayDocuments[index].idApprovedConnection,
        "status": 'Activo',
        "editedDate": new Date(),
        "createdDate": new Date()
      }

      axios.post("approvedConnectionDocument/add/" + this.requestDetail.id, newObjectApprovedDocument, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      }).then((result) => {
        if (index < this.arrayDocuments.length - 1) {
          this.sendApprovedConnectionDocument(index + 1);
        }else{
          this.loading = false;
          this.$router.go(-1);
          return;
        }
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tardeee.';
        return;
      })


      
      /*let newObjectApprovedDocument = {
        "anexo": this.arrayDocuments[index].anexo,
        "description": this.arrayDocuments[index].description,
        "idApprovedConnection": this.arrayDocuments[index].idApprovedConnection,
        "status": 'Activo',
        "editedDate": new Date(),
        "createdDate": new Date()
      }

      axios.post("approvedConnectionDocument/add", newObjectApprovedDocument, {
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
      })
      .then((result) => {
        if (index < this.arrayDocuments.length - 1) {
          this.sendApprovedConnectionDocument(index + 1);
        }else{
          this.loading = false;
          this.$router.go(-1);
          return;
        }
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tardeee.';
        return;
      })*/

    },    
    updateRequest(){
      let requestData;
      let search = this.requestDetail.serviceDetail.requestedService.id;
      
      if(search==9 || search==10){
        requestData = {
        "id":this.requestDetail.id,
        "conectionType":this.requestDetail.conectionType,
        "proyectName":this.requestDetail.proyectName,
        "observactions":this.requestDetail.observactions,
        "stage":"finalizado",
        "status":"finalizado",
        "applicantInfo":{
          "id":this.requestDetail.applicantInfo.id
        },
        "electricInfrastructure":{
          "id":this.requestDetail.electricInfrastructure.id
        },
        "estateInfo":{
          "id":this.requestDetail.estateInfo.id
        },
        "serviceDetail":{
          "id":this.requestDetail.serviceDetail.id
        },
        "subscriptorInfo":{
          "id":this.requestDetail.subscriptorInfo.id
        },
        "typesUseEconomicActivity":{
          "id":this.requestDetail.typesUseEconomicActivity.id
        },
        "createdDate": this.requestDetail.createdDate,
        "editedDate": new Date()
      }
      }else{
        requestData = {
        "id":this.requestDetail.id,
        "conectionType":this.requestDetail.conectionType,
        "proyectName":this.requestDetail.proyectName,
        "observactions":this.requestDetail.observactions,
        "stage":"pendiente-disenos",
        "status":"en proceso",
        "applicantInfo":{
          "id":this.requestDetail.applicantInfo.id
        },
        "electricInfrastructure":{
          "id":this.requestDetail.electricInfrastructure.id
        },
        "estateInfo":{
          "id":this.requestDetail.estateInfo.id
        },
        "serviceDetail":{
          "id":this.requestDetail.serviceDetail.id
        },
        "subscriptorInfo":{
          "id":this.requestDetail.subscriptorInfo.id
        },
        "typesUseEconomicActivity":{
          "id":this.requestDetail.typesUseEconomicActivity.id
        },
        "createdDate": this.requestDetail.createdDate,
        "editedDate": new Date()
      }

      }
       
      axios.post("request/update", requestData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.setRequestDetail(result.data);
        this.loading = false;
        this.$router.push('adminRequestDetail');
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })

    },
    ...mapMutations({
      setRequestDetail: 'setRequestDetail'
    }),
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;  
}
</style>